import { createTheme } from '@mui/material';


export const theme = createTheme({
	palette: {
		 primary: {
				main: 'rgb(78, 175, 10)',
				contrastText: '#ffffff'
		 },
		 secondary: {
				main: 'rgb(225, 82, 65)',
				contrastText: '#ffffff'
		 },
	},
	
});